<template>
  <svg
    width="241"
    height="570"
    viewBox="0 0 241 570"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="BOT SALMONE">
      <g id="barccio sx">
        <g id="Group 806">
          <g id="Rectangle 539" filter="url(#filter0_i_2963_675)">
            <path
              d="M235.032 320.921C236.192 313.305 230.958 306.191 223.341 305.031C215.725 303.871 208.61 309.105 207.451 316.722L202.557 348.862C201.397 356.478 206.631 363.593 214.248 364.752C221.864 365.912 228.979 360.678 230.138 353.061L235.032 320.921Z"
              :fill="hands"
            />
          </g>
          <g id="Rectangle 538" filter="url(#filter1_i_2963_675)">
            <path
              d="M227.386 243.929C226.189 235.805 218.634 230.19 210.51 231.387C202.387 232.583 196.772 240.139 197.968 248.262L204.899 295.309C206.095 303.432 213.651 309.048 221.774 307.851C229.897 306.654 235.513 299.099 234.316 290.976L227.386 243.929Z"
              :fill="hands"
            />
          </g>
          <g id="Ellipse 26" filter="url(#filter2_di_2963_675)">
            <path
              d="M220.631 232.324C220.631 241.751 212.988 249.394 203.561 249.394C194.133 249.394 186.491 241.751 186.491 232.324C186.491 222.896 194.133 215.254 203.561 215.254C212.988 215.254 220.631 222.896 220.631 232.324Z"
              fill="url(#paint2_linear_2963_675)"
            />
          </g>
          <g id="Ellipse 30" filter="url(#filter3_di_2963_675)">
            <path
              d="M236.925 307.586C236.925 315.3 230.672 321.553 222.958 321.553C215.245 321.553 208.992 315.3 208.992 307.586C208.992 299.873 215.245 293.62 222.958 293.62C230.672 293.62 236.925 299.873 236.925 307.586Z"
              fill="url(#paint3_linear_2963_675)"
            />
          </g>
        </g>
      </g>
      <g id="mano sx">
        <g id="Polygon 19" filter="url(#filter4_i_2963_675)">
          <path
            d="M215.028 378.951C211.762 382.296 206.097 380.817 204.883 376.303L197.946 350.519C196.743 346.047 200.818 341.942 205.299 343.112L230.89 349.793C235.371 350.963 236.919 356.536 233.683 359.849L215.028 378.951Z"
            :fill="hands"
          />
        </g>
        <g id="Group 797">
          <g id="Rectangle 524" filter="url(#filter5_di_2963_675)">
            <path
              d="M201.019 391.803C201.856 389.112 204.715 387.61 207.405 388.446C210.096 389.283 211.598 392.142 210.762 394.833L205.567 411.534C204.731 414.225 201.871 415.727 199.181 414.89C196.491 414.054 194.988 411.195 195.825 408.504L201.019 391.803Z"
              fill="url(#paint5_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 529" filter="url(#filter6_di_2963_675)">
            <path
              d="M210.429 388.973C210.695 386.168 213.184 384.109 215.989 384.375C218.794 384.641 220.852 387.13 220.586 389.935L218.936 407.348C218.67 410.153 216.181 412.211 213.376 411.945C210.571 411.679 208.513 409.19 208.778 406.385L210.429 388.973Z"
              fill="url(#paint6_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 527" filter="url(#filter7_di_2963_675)">
            <path
              d="M191.922 360.381C194.283 358.844 197.443 359.512 198.98 361.873C200.517 364.234 199.849 367.395 197.488 368.932L184.025 377.696C181.664 379.234 178.504 378.566 176.967 376.204C175.43 373.843 176.098 370.683 178.459 369.146L191.922 360.381Z"
              fill="url(#paint7_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 525" filter="url(#filter8_di_2963_675)">
            <path
              d="M194.475 385.849C195.968 383.461 199.116 382.735 201.505 384.229C203.894 385.723 204.619 388.871 203.125 391.259L193.078 407.325C191.584 409.713 188.437 410.439 186.048 408.945C183.659 407.451 182.934 404.304 184.428 401.915L194.475 385.849Z"
              fill="url(#paint8_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 526" filter="url(#filter9_di_2963_675)">
            <path
              d="M189.283 377.081C191.084 374.914 194.3 374.617 196.467 376.418C198.634 378.219 198.93 381.436 197.129 383.603L183.72 399.733C181.919 401.9 178.703 402.196 176.536 400.395C174.37 398.594 174.073 395.378 175.874 393.211L189.283 377.081Z"
              fill="url(#paint9_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 528" filter="url(#filter10_i_2963_675)">
            <path
              d="M221.377 389.067C217.614 395.8 209.105 398.208 202.372 394.444L194.947 390.294C188.214 386.531 185.806 378.022 189.569 371.289L193.719 363.864C197.483 357.131 205.992 354.723 212.725 358.486L220.15 362.636C226.883 366.4 229.291 374.909 225.527 381.642L221.377 389.067Z"
              :fill="hands"
            />
          </g>
        </g>
      </g>
      <g id="braccio dx">
        <g id="Group 807">
          <g id="Rectangle 539_2" filter="url(#filter11_i_2963_675)">
            <path
              d="M3.89281 320.921C2.73313 313.305 7.96735 306.191 15.5838 305.031C23.2002 303.871 30.3146 309.105 31.4743 316.722L36.368 348.862C37.5277 356.478 32.2935 363.593 24.677 364.752C17.0606 365.912 9.94616 360.678 8.78648 353.061L3.89281 320.921Z"
              :fill="hands"
            />
          </g>
          <g id="Rectangle 538_2" filter="url(#filter12_i_2963_675)">
            <path
              d="M11.5388 243.929C12.7354 235.805 20.2908 230.19 28.4142 231.387C36.5376 232.583 42.1529 240.139 40.9563 248.262L34.0259 295.309C32.8293 303.432 25.2739 309.048 17.1505 307.851C9.02709 306.654 3.41182 299.099 4.60846 290.976L11.5388 243.929Z"
              :fill="hands"
            />
          </g>
          <g id="Ellipse 26_2" filter="url(#filter13_di_2963_675)">
            <path
              d="M18.2944 232.324C18.2944 241.751 25.9369 249.394 35.3644 249.394C44.7918 249.394 52.4343 241.751 52.4343 232.324C52.4343 222.896 44.7918 215.254 35.3644 215.254C25.9369 215.254 18.2944 222.896 18.2944 232.324Z"
              fill="url(#paint13_linear_2963_675)"
            />
          </g>
          <g id="Ellipse 30_2" filter="url(#filter14_di_2963_675)">
            <path
              d="M2 307.586C2 315.3 8.25293 321.553 15.9663 321.553C23.6797 321.553 29.9326 315.3 29.9326 307.586C29.9326 299.873 23.6797 293.62 15.9663 293.62C8.25293 293.62 2 299.873 2 307.586Z"
              fill="url(#paint14_linear_2963_675)"
            />
          </g>
        </g>
      </g>
      <g id="mano dx">
        <g id="Polygon 19_2" filter="url(#filter15_i_2963_675)">
          <path
            d="M23.8971 378.951C27.1633 382.296 32.828 380.817 34.0425 376.303L40.9787 350.519C42.1818 346.047 38.1074 341.942 33.6264 343.112L8.03536 349.793C3.55438 350.963 2.00652 356.536 5.24222 359.849L23.8971 378.951Z"
            :fill="hands"
          />
        </g>
        <g id="Group 797_2">
          <g id="Rectangle 524_2" filter="url(#filter16_di_2963_675)">
            <path
              d="M37.9062 391.803C37.0695 389.112 34.2103 387.61 31.5199 388.446C28.8296 389.283 27.3269 392.142 28.1636 394.833L33.3579 411.534C34.1946 414.225 37.0538 415.727 39.7441 414.89C42.4345 414.054 43.9372 411.195 43.1004 408.504L37.9062 391.803Z"
              fill="url(#paint16_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 529_2" filter="url(#filter17_di_2963_675)">
            <path
              d="M28.4959 388.973C28.23 386.168 25.7407 384.109 22.9359 384.375C20.131 384.641 18.0727 387.13 18.3385 389.935L19.9889 407.348C20.2548 410.153 22.7441 412.211 25.549 411.945C28.3538 411.679 30.4121 409.19 30.1463 406.385L28.4959 388.973Z"
              fill="url(#paint17_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 527_2" filter="url(#filter18_di_2963_675)">
            <path
              d="M47.003 360.381C44.6418 358.844 41.4816 359.512 39.9444 361.873C38.4073 364.234 39.0753 367.395 41.4364 368.932L54.8993 377.696C57.2605 379.234 60.4207 378.566 61.9579 376.204C63.495 373.843 62.827 370.683 60.4659 369.146L47.003 360.381Z"
              fill="url(#paint18_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 525_2" filter="url(#filter19_di_2963_675)">
            <path
              d="M44.4503 385.849C42.9565 383.461 39.8089 382.735 37.4201 384.229C35.0314 385.723 34.3059 388.871 35.7998 391.259L45.8466 407.325C47.3405 409.713 50.4881 410.439 52.8768 408.945C55.2656 407.451 55.9911 404.304 54.4972 401.915L44.4503 385.849Z"
              fill="url(#paint19_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 526_2" filter="url(#filter20_di_2963_675)">
            <path
              d="M49.6423 377.081C47.8413 374.914 44.6249 374.617 42.4582 376.418C40.2916 378.219 39.9952 381.436 41.7962 383.603L55.2047 399.733C57.0057 401.9 60.2221 402.196 62.3888 400.395C64.5554 398.594 64.8518 395.378 63.0508 393.211L49.6423 377.081Z"
              fill="url(#paint20_linear_2963_675)"
            />
          </g>
          <g id="Rectangle 528_2" filter="url(#filter21_i_2963_675)">
            <path
              d="M17.5476 389.067C21.3108 395.8 29.8197 398.207 36.5528 394.444L43.978 390.294C50.7111 386.531 53.1186 378.022 49.3554 371.289L45.2054 363.864C41.4422 357.131 32.9333 354.723 26.2002 358.486L18.775 362.636C12.042 366.4 9.6344 374.908 13.3976 381.642L17.5476 389.067Z"
              :fill="hands"
            />
          </g>
        </g>
      </g>
      <g id="bacino" filter="url(#filter22_di_2963_675)">
        <path
          id="Rectangle 513"
          d="M52.9629 378.696C52.9629 390.462 61.609 400 72.2745 400H163.651C174.317 400 182.963 390.462 182.963 378.696C182.963 351.802 163.2 330 138.822 330H97.1037C72.7254 330 52.9629 351.802 52.9629 378.696Z"
          :fill="body"
        />
        <g id="Subtract" filter="url(#filter23_i_2963_675)">
          <path
            d="M66.6737 305C62.9674 305 59.9629 308.005 59.9629 311.711V325.739C59.9629 347.518 77.6188 365.174 99.3985 365.174H134.891C156.67 365.174 174.326 347.518 174.326 325.739V311.711C174.326 308.005 171.322 305 167.615 305H66.6737Z"
            fill="url(#paint23_linear_2963_675)"
          />
        </g>
      </g>
      <g id="Body">
        <path
          id="Rectangle 512"
          d="M35.9648 231.11C35.9648 219.353 45.4957 209.822 57.2525 209.822H180.721C192.478 209.822 202.009 219.353 202.009 231.11L200.463 282.5C192.417 315.833 175.955 339.36 143.816 339.36H94.1578C62.0187 339.36 45.4609 319 38.9629 281.167L35.9648 231.11Z"
          :fill="body"
        />
        <g id="Subtract_2">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.5664 304.032C53.102 326.469 69.4774 339.36 94.158 339.36H143.816C167.788 339.36 184.455 324.695 193.452 304.032H44.5664Z"
            :fill="body"
          />
        </g>
      </g>
      <g id="collo" filter="url(#filter26_di_2963_675)">
        <path
          d="M122.423 152.699C122.151 152.147 121.809 151.62 121.321 151.245C119.101 149.54 115.963 149.59 113.796 151.394C113.443 151.688 113.172 152.065 112.938 152.46L84.4629 200.5L56.8447 211.64C56.0505 211.96 55.2948 212.423 54.8445 213.151C52.7379 216.558 54.5516 221.25 58.7411 222.038C78.574 225.771 97.5449 269.411 117.963 269.5C137.429 269.585 158.348 226.305 177.119 222.27C181.131 221.408 182.812 216.945 180.874 213.632C180.395 212.813 179.539 212.32 178.645 212.005L145.963 200.5L122.423 152.699Z"
          fill="url(#paint26_linear_2963_675)"
        />
      </g>
      <g id="Casco" filter="url(#filter27_i_2963_675)">
        <path
          d="M202.963 103.483C182.88 161.78 160.938 198 112.963 198C69.4505 198 39.6984 162.815 22.9629 103.483C22.9629 51.8536 46.3926 10 112.963 10C176.186 10 202.963 51.8536 202.963 103.483Z"
          :fill="face"
        />
      </g>
      <g id="bocca">
        <g id="Rectangle 540" filter="url(#filter28_di_2963_675)">
          <path
            d="M43.1634 155.591C43.0209 154.917 42.8965 154.205 43.133 153.558C44.7224 149.208 57.0464 151.637 63.0933 152.027C63.9861 152.084 64.8737 151.971 65.7437 151.763L116.963 139.5L161.001 151.665C161.99 151.938 163.007 152.085 164.031 152.013C170.578 151.555 183.963 148.915 183.963 154.576C182.963 169 176.385 186.651 162.492 193.076C114.868 215.103 116.407 215.144 66.4629 193.076C54.8235 187.934 45.5361 166.823 43.1634 155.591Z"
            fill="url(#paint28_linear_2963_675)"
          />
        </g>
        <path
          id="Rectangle 541"
          d="M103.584 178.362C103.584 177.1 104.503 176.077 105.636 176.077H124.912C126.052 176.077 126.976 177.106 126.976 178.375C126.976 179.478 126.268 180.428 125.293 180.629C116.808 182.38 114.395 182.373 105.283 180.61C104.303 180.42 103.584 179.47 103.584 178.362Z"
          fill="black"
        />
      </g>
      <g id="Gamba dx">
        <g id="Rectangle 544" filter="url(#filter29_i_2963_675)">
          <path
            d="M54.4044 406.495C55.0563 394.721 65.1291 385.706 76.9024 386.357C88.6758 387.009 97.6916 397.082 97.0396 408.856L95.2983 440.301C94.6464 452.075 84.5737 461.091 72.8003 460.439C61.0269 459.787 52.0112 449.714 52.6631 437.941L54.4044 406.495Z"
            :fill="feet"
          />
        </g>
        <g id="Rectangle 546" filter="url(#filter30_i_2963_675)">
          <path
            d="M53.2224 469.114C52.69 458.067 61.2142 448.679 72.2617 448.147C83.3092 447.615 92.6965 456.139 93.2288 467.186L95.1231 506.499C95.6554 517.546 87.1312 526.933 76.0837 527.466C65.0362 527.998 55.649 519.474 55.1166 508.426L53.2224 469.114Z"
            :fill="feet"
          />
        </g>
        <g id="Rectangle 548" filter="url(#filter31_di_2963_675)">
          <path
            d="M71.2688 442.594C79.1965 442.594 85.6231 449.021 85.6231 456.948C85.6231 464.876 79.1965 471.303 71.2688 471.303H70.4929C62.5653 471.303 56.1387 464.876 56.1387 456.948C56.1387 449.021 62.5653 442.594 70.4929 442.594L71.2688 442.594Z"
            fill="url(#paint31_linear_2963_675)"
          />
        </g>
        <g id="Ellipse 33" filter="url(#filter32_di_2963_675)">
          <path
            d="M92.6061 393.324C92.6061 402.109 85.4847 409.23 76.7 409.23C67.9153 409.23 60.7939 402.109 60.7939 393.324C60.7939 384.539 67.9153 377.418 76.7 377.418C85.4847 377.418 92.6061 384.539 92.6061 393.324Z"
            fill="url(#paint32_linear_2963_675)"
          />
        </g>
      </g>
      <g id="Gamba sx">
        <g id="Rectangle 545" filter="url(#filter33_i_2963_675)">
          <path
            d="M183.569 406.495C182.917 394.721 172.844 385.706 161.071 386.357C149.297 387.009 140.282 397.082 140.934 408.856L142.675 440.301C143.327 452.075 153.4 461.091 165.173 460.439C176.946 459.787 185.962 449.714 185.31 437.941L183.569 406.495Z"
            :fill="feet"
          />
        </g>
        <g id="Rectangle 547" filter="url(#filter34_i_2963_675)">
          <rect
            width="40.0528"
            height="79.4108"
            rx="20.0264"
            transform="matrix(-0.998841 -0.0481295 -0.0481295 0.998841 185.714 449.111)"
            :fill="feet"
          />
        </g>
        <g id="Rectangle 549" filter="url(#filter35_di_2963_675)">
          <path
            d="M166.705 442.594C158.777 442.594 152.351 449.021 152.351 456.948C152.351 464.876 158.777 471.303 166.705 471.303H167.481C175.408 471.303 181.835 464.876 181.835 456.948C181.835 449.021 175.408 442.594 167.481 442.594L166.705 442.594Z"
            fill="url(#paint35_linear_2963_675)"
          />
        </g>
        <g id="Ellipse 34" filter="url(#filter36_di_2963_675)">
          <path
            d="M145.368 393.324C145.368 402.109 152.489 409.23 161.274 409.23C170.058 409.23 177.18 402.109 177.18 393.324C177.18 384.539 170.058 377.418 161.274 377.418C152.489 377.418 145.368 384.539 145.368 393.324Z"
            fill="url(#paint36_linear_2963_675)"
          />
        </g>
      </g>
      <g id="piede dx">
        <g id="Rectangle 453" filter="url(#filter37_di_2963_675)">
          <path
            d="M105.796 506.994C105.796 496.281 97.1115 487.597 86.3985 487.597H63.1213C52.4083 487.597 43.7236 496.281 43.7236 506.994V544.238C43.7236 554.951 52.4083 563.635 63.1213 563.635H86.3985C97.1115 563.635 105.796 554.951 105.796 544.238V506.994Z"
            :fill="feet"
          />
        </g>
        <path
          id="Rectangle 446"
          d="M31.6969 546.566C25.4834 546.566 20.4463 551.603 20.4463 557.816C20.4463 564.03 25.4834 569.067 31.6969 569.067L100.753 569.067C106.966 569.067 112.003 564.03 112.003 557.816C112.003 551.603 106.966 546.566 100.753 546.566L31.6969 546.566Z"
          fill="url(#paint38_linear_2963_675)"
        />
        <g id="Ellipse 6" filter="url(#filter38_di_2963_675)">
          <path
            d="M104.244 546.954C104.244 537.385 100.198 528.208 92.9952 521.441C85.7924 514.675 76.0233 510.874 65.8371 510.874C55.6508 510.874 45.8817 514.675 38.6789 521.441C31.4762 528.208 27.4297 537.385 27.4297 546.954L104.244 546.954Z"
            :fill="feet"
          />
        </g>
      </g>
      <g id="piede sx">
        <g id="Rectangle 453_2" filter="url(#filter39_di_2963_675)">
          <path
            d="M132.177 506.994C132.177 496.281 140.862 487.597 151.575 487.597H174.852C185.565 487.597 194.25 496.281 194.25 506.994V544.238C194.25 554.951 185.565 563.635 174.852 563.635H151.575C140.862 563.635 132.177 554.951 132.177 544.238V506.994Z"
            :fill="feet"
          />
        </g>
        <path
          id="Rectangle 446_2"
          d="M206.277 546.566C212.49 546.566 217.527 551.603 217.527 557.816C217.527 564.03 212.49 569.067 206.277 569.067L137.221 569.067C131.007 569.067 125.97 564.03 125.97 557.816C125.97 551.603 131.007 546.566 137.221 546.566L206.277 546.566Z"
          fill="url(#paint41_linear_2963_675)"
        />
        <g id="Ellipse 6_2" filter="url(#filter40_di_2963_675)">
          <path
            d="M133.729 546.954C133.729 537.385 137.776 528.208 144.979 521.441C152.182 514.675 161.951 510.874 172.137 510.874C182.323 510.874 192.092 514.675 199.295 521.441C206.498 528.208 210.544 537.385 210.544 546.954L133.729 546.954Z"
            :fill="feet"
          />
        </g>
      </g>
      <path
        id="orecchio dx"
        d="M35.4539 21.7374C34.9961 19.1363 38.0768 17.0689 40.3047 18.4873C43.2406 20.3565 46.7126 22.4001 49.6573 23.6703C53.4759 25.3174 58.8952 26.7369 62.7668 27.6373C64.8879 28.1306 65.7763 30.731 64.3421 32.3698C55.3611 42.632 52.503 44.483 39.2925 48.7641C37.2752 49.4178 35.2667 47.686 35.5606 45.5858C36.1106 41.6548 36.7666 36.0409 36.6633 32.2209C36.5733 28.893 36.034 25.0335 35.4539 21.7374Z"
        :fill="face"
      />
      <path
        id="orecchio sx"
        d="M192.088 24.7374C192.545 22.1363 189.465 20.0689 187.237 21.4873C184.301 23.3565 180.829 25.4001 177.884 26.6703C174.066 28.3174 168.646 29.7369 164.775 30.6373C162.654 31.1306 161.765 33.731 163.199 35.3698C172.18 45.632 175.039 47.483 188.249 51.7641C190.266 52.4178 192.275 50.686 191.981 48.5858C191.431 44.6548 190.775 39.0409 190.878 35.2209C190.968 31.8931 191.508 28.0335 192.088 24.7374Z"
        :fill="face"
      />
      <g id="Maschera" filter="url(#filter41_di_2963_675)">
        <mask id="path-47-inside-1_2963_675" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M116.324 146.333C115.826 145.658 114.803 145.658 114.305 146.333C104.695 159.342 88.2616 167.916 69.6031 167.916C39.9785 167.916 15.9629 146.302 15.9629 119.639C15.9629 105.536 22.6824 92.8455 33.3972 84.019C33.5091 83.9268 33.6365 83.8565 33.7742 83.8113C43.2239 80.7151 55.3045 79.9388 71.9872 82.686C96.4147 86.7087 108.339 102.966 114.129 116.842C114.557 117.868 116.073 117.868 116.501 116.842C122.29 102.966 134.215 86.7087 158.642 82.686C175.324 79.9389 187.405 80.7151 196.854 83.8108C196.992 83.856 197.119 83.9263 197.231 84.0185C207.946 92.845 214.666 105.536 214.666 119.64C214.666 146.302 190.651 167.916 161.026 167.916C142.367 167.916 125.934 159.342 116.324 146.333Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M116.324 146.333C115.826 145.658 114.803 145.658 114.305 146.333C104.695 159.342 88.2616 167.916 69.6031 167.916C39.9785 167.916 15.9629 146.302 15.9629 119.639C15.9629 105.536 22.6824 92.8455 33.3972 84.019C33.5091 83.9268 33.6365 83.8565 33.7742 83.8113C43.2239 80.7151 55.3045 79.9388 71.9872 82.686C96.4147 86.7087 108.339 102.966 114.129 116.842C114.557 117.868 116.073 117.868 116.501 116.842C122.29 102.966 134.215 86.7087 158.642 82.686C175.324 79.9389 187.405 80.7151 196.854 83.8108C196.992 83.856 197.119 83.9263 197.231 84.0185C207.946 92.845 214.666 105.536 214.666 119.64C214.666 146.302 190.651 167.916 161.026 167.916C142.367 167.916 125.934 159.342 116.324 146.333Z"
          :fill="mask"
        />
        <path
          d="M71.9872 82.686L71.4062 86.2145L71.9872 82.686ZM158.642 82.686L158.061 79.1575V79.1575L158.642 82.686ZM196.854 83.8108L195.741 87.2091L196.854 83.8108ZM197.231 84.0185L194.957 86.7786L197.231 84.0185ZM114.129 116.842L117.429 115.465L114.129 116.842ZM116.501 116.842L113.201 115.465L116.501 116.842ZM33.3972 84.019L31.1235 81.2588L33.3972 84.019ZM33.7742 83.8113L34.8876 87.2096L33.7742 83.8113ZM114.305 146.333L111.428 144.208L114.305 146.333ZM116.324 146.333L119.201 144.208L116.324 146.333ZM69.6031 171.492C89.3477 171.492 106.869 162.418 117.181 148.457L111.428 144.208C102.521 156.266 87.1755 164.34 69.6031 164.34V171.492ZM12.3869 119.639C12.3869 148.622 38.3672 171.492 69.6031 171.492V164.34C41.5897 164.34 19.5389 143.982 19.5389 119.639H12.3869ZM31.1235 81.2588C19.6789 90.6865 12.3869 104.351 12.3869 119.639H19.5389C19.5389 106.722 25.6859 95.0044 35.6709 86.7791L31.1235 81.2588ZM72.5683 79.1575C55.5219 76.3504 42.8237 77.0832 32.6608 80.4131L34.8876 87.2096C43.6241 84.3471 55.0872 83.5272 71.4062 86.2145L72.5683 79.1575ZM117.429 115.465C111.347 100.889 98.6163 83.447 72.5683 79.1575L71.4062 86.2145C94.2131 89.9703 105.331 105.044 110.828 118.219L117.429 115.465ZM119.801 118.219C125.298 105.044 136.417 89.9703 159.223 86.2145L158.061 79.1575C132.013 83.447 119.282 100.889 113.201 115.465L119.801 118.219ZM159.223 86.2145C175.542 83.5273 187.004 84.347 195.741 87.2091L197.967 80.4125C187.805 77.0831 175.107 76.3505 158.061 79.1575L159.223 86.2145ZM194.957 86.7786C204.943 95.004 211.09 106.722 211.09 119.64H218.242C218.242 104.351 210.95 90.686 199.505 81.2583L194.957 86.7786ZM211.09 119.64C211.09 143.982 189.039 164.34 161.026 164.34V171.492C192.262 171.492 218.242 148.622 218.242 119.64H211.09ZM161.026 164.34C143.453 164.34 128.108 156.266 119.201 144.208L113.448 148.457C123.76 162.418 141.281 171.492 161.026 171.492V164.34ZM195.741 87.2091C195.451 87.1143 195.186 86.9669 194.957 86.7786L199.505 81.2583C199.052 80.8857 198.532 80.5976 197.967 80.4125L195.741 87.2091ZM110.828 118.219C112.48 122.177 118.15 122.177 119.801 118.219L113.201 115.465C113.623 114.453 114.58 114.035 115.315 114.035C116.05 114.035 117.006 114.453 117.429 115.465L110.828 118.219ZM35.6709 86.7791C35.4424 86.9673 35.177 87.1148 34.8876 87.2096L32.6608 80.4131C32.0959 80.5981 31.5758 80.8863 31.1235 81.2588L35.6709 86.7791ZM117.181 148.457C116.25 149.718 114.379 149.718 113.448 148.457L119.201 144.208C117.273 141.599 113.356 141.598 111.428 144.208L117.181 148.457Z"
          fill="#D6D6D6"
          mask="url(#path-47-inside-1_2963_675)"
        />
      </g>
      <g id="Tondo casco" filter="url(#filter42_di_2963_675)">
        <path
          d="M142.604 29.3206C142.604 44.9616 129.924 57.6412 114.283 57.6412C98.6424 57.6412 85.9629 44.9616 85.9629 29.3206C85.9629 13.6796 98.6424 1 114.283 1C129.924 1 142.604 13.6796 142.604 29.3206Z"
          fill="url(#paint46_linear_2963_675)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_2963_675"
        x="202.396"
        y="299.74"
        width="33.9503"
        height="65.1737"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.15338" dy="-5.13033" />
        <feGaussianBlur stdDeviation="25.453" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter1_i_2963_675"
        x="197.808"
        y="226.096"
        width="37.8228"
        height="81.9161"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.15338" dy="-5.13033" />
        <feGaussianBlur stdDeviation="25.453" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter2_di_2963_675"
        x="184.726"
        y="214.371"
        width="39.4345"
        height="39.4347"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter3_di_2963_675"
        x="207.227"
        y="292.738"
        width="33.2274"
        height="33.2274"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter4_i_2963_675"
        x="197.733"
        y="342.91"
        width="40.9588"
        height="41.1507"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter5_di_2963_675"
        x="193.828"
        y="387.332"
        width="20.6947"
        height="32.2019"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter6_di_2963_675"
        x="206.99"
        y="383.47"
        width="17.1488"
        height="32.911"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter7_di_2963_675"
        x="174.375"
        y="358.672"
        width="28.9618"
        height="24.2634"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter8_di_2963_675"
        x="181.886"
        y="382.57"
        width="25.5458"
        height="31.5643"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter9_di_2963_675"
        x="172.931"
        y="374.358"
        width="28.9066"
        height="31.6287"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter10_i_2963_675"
        x="187.792"
        y="356.709"
        width="42.8001"
        height="42.8002"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter11_i_2963_675"
        x="3.73193"
        y="299.74"
        width="33.9503"
        height="65.1737"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.15338" dy="-5.13033" />
        <feGaussianBlur stdDeviation="25.453" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter12_i_2963_675"
        x="4.44775"
        y="226.096"
        width="37.8228"
        height="81.9161"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.15338" dy="-5.13033" />
        <feGaussianBlur stdDeviation="25.453" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter13_di_2963_675"
        x="16.5295"
        y="214.371"
        width="39.4345"
        height="39.4347"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter14_di_2963_675"
        x="0.235061"
        y="292.738"
        width="33.2274"
        height="33.2274"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter15_i_2963_675"
        x="3.521"
        y="342.91"
        width="40.9588"
        height="41.1507"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter16_di_2963_675"
        x="26.1672"
        y="387.332"
        width="20.6947"
        height="32.2019"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter17_di_2963_675"
        x="16.5505"
        y="383.47"
        width="17.1488"
        height="32.911"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter18_di_2963_675"
        x="37.3527"
        y="358.672"
        width="28.9618"
        height="24.2634"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter19_di_2963_675"
        x="33.258"
        y="382.57"
        width="25.5458"
        height="31.5643"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter20_di_2963_675"
        x="38.8527"
        y="374.358"
        width="28.9066"
        height="31.6287"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter21_i_2963_675"
        x="11.6201"
        y="356.709"
        width="42.8001"
        height="42.8002"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter22_di_2963_675"
        x="51.0003"
        y="304.019"
        width="135.888"
        height="100.888"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.981289" dy="1.96258" />
        <feGaussianBlur stdDeviation="1.47193" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.65552" dy="3.65552" />
        <feGaussianBlur stdDeviation="15.536" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter23_i_2963_675"
        x="57.3339"
        y="305"
        width="116.992"
        height="62.8032"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.62904" dy="2.62904" />
        <feGaussianBlur stdDeviation="6.5726" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter24_i_2963_675"
        x="35.9648"
        y="204.212"
        width="167.305"
        height="135.148"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.26117" dy="-5.6098" />
        <feGaussianBlur stdDeviation="27.8318" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter25_i_2963_675"
        x="41.728"
        y="304.032"
        width="151.724"
        height="38.1667"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.83836" dy="2.83836" />
        <feGaussianBlur stdDeviation="7.09589" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.972549 0 0 0 0 0.403922 0 0 0 0 0.490196 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter26_di_2963_675"
        x="52.198"
        y="149.12"
        width="133.011"
        height="124.792"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter27_i_2963_675"
        x="22.9629"
        y="4.3902"
        width="181.261"
        height="193.61"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.26117" dy="-5.6098" />
        <feGaussianBlur stdDeviation="27.8318" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter28_di_2963_675"
        x="39.6643"
        y="137.832"
        width="150.971"
        height="80.12"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.6681" dy="3.3362" />
        <feGaussianBlur stdDeviation="2.50215" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="6.21405" dy="6.21405" />
        <feGaussianBlur stdDeviation="26.4097" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter29_i_2963_675"
        x="52.6299"
        y="381.194"
        width="45.5962"
        height="79.2779"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.15338" dy="-5.13033" />
        <feGaussianBlur stdDeviation="25.453" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter30_i_2963_675"
        x="53.1987"
        y="442.993"
        width="43.1011"
        height="84.4964"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.15338" dy="-5.13033" />
        <feGaussianBlur stdDeviation="25.453" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter31_di_2963_675"
        x="54.3737"
        y="441.712"
        width="34.7792"
        height="34.0033"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter32_di_2963_675"
        x="59.029"
        y="376.535"
        width="37.1068"
        height="37.107"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter33_i_2963_675"
        x="140.9"
        y="381.194"
        width="45.5962"
        height="79.2779"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.15338" dy="-5.13033" />
        <feGaussianBlur stdDeviation="25.453" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter34_i_2963_675"
        x="142.826"
        y="442.993"
        width="43.1011"
        height="84.4964"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.15338" dy="-5.13033" />
        <feGaussianBlur stdDeviation="25.453" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter35_di_2963_675"
        x="150.586"
        y="441.712"
        width="34.7792"
        height="34.0033"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter36_di_2963_675"
        x="143.603"
        y="376.535"
        width="37.1068"
        height="37.107"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter37_di_2963_675"
        x="41.7611"
        y="486.615"
        width="67.96"
        height="81.9266"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.981289" dy="1.96258" />
        <feGaussianBlur stdDeviation="1.47193" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.65552" dy="3.65552" />
        <feGaussianBlur stdDeviation="15.536" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter38_di_2963_675"
        x="25.4671"
        y="509.893"
        width="82.7027"
        height="41.9673"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.981289" dy="1.96258" />
        <feGaussianBlur stdDeviation="1.47193" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.65552" dy="3.65552" />
        <feGaussianBlur stdDeviation="15.536" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter39_di_2963_675"
        x="130.215"
        y="486.615"
        width="67.96"
        height="81.9266"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.981289" dy="1.96258" />
        <feGaussianBlur stdDeviation="1.47193" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.65552" dy="3.65552" />
        <feGaussianBlur stdDeviation="15.536" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter40_di_2963_675"
        x="131.767"
        y="509.893"
        width="82.7027"
        height="41.9673"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.981289" dy="1.96258" />
        <feGaussianBlur stdDeviation="1.47193" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.65552" dy="3.65552" />
        <feGaussianBlur stdDeviation="15.536" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter41_di_2963_675"
        x="13.0413"
        y="79.5392"
        width="207.468"
        height="95.6806"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.46079" dy="2.92157" />
        <feGaussianBlur stdDeviation="2.19118" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="5.44175" dy="5.44175" />
        <feGaussianBlur stdDeviation="23.1275" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <filter
        id="filter42_di_2963_675"
        x="84.198"
        y="0.11753"
        width="61.9359"
        height="61.936"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.88247" dy="1.76494" />
        <feGaussianBlur stdDeviation="1.3237" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2963_675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2963_675"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.2874" dy="3.2874" />
        <feGaussianBlur stdDeviation="13.9714" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2963_675"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2963_675"
        x1="237.957"
        y1="337.06"
        x2="185.796"
        y2="338.077"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#3A1C9D" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2963_675"
        x1="236.324"
        y1="265.688"
        x2="182.786"
        y2="281.594"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#3A1C9D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2963_675"
        x1="203.468"
        y1="238.638"
        x2="203.468"
        y2="266.782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2963_675"
        x1="222.883"
        y1="312.753"
        x2="222.883"
        y2="335.779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2963_675"
        x1="204.769"
        y1="352.772"
        x2="226.773"
        y2="368.477"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#FF5E76" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2963_675"
        x1="203.251"
        y1="406.645"
        x2="203.251"
        y2="428.826"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2963_675"
        x1="214.65"
        y1="403.268"
        x2="214.65"
        y2="426.034"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2963_675"
        x1="187.909"
        y1="372.547"
        x2="187.909"
        y2="388.184"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2963_675"
        x1="193.721"
        y1="401.446"
        x2="193.721"
        y2="423.102"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2963_675"
        x1="186.438"
        y1="393.277"
        x2="186.438"
        y2="414.986"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2963_675"
        x1="195.172"
        y1="367"
        x2="218.172"
        y2="383.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#FF5E76" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2963_675"
        x1="0.967481"
        y1="337.06"
        x2="53.1287"
        y2="338.077"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#3A1C9D" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2963_675"
        x1="2.60117"
        y1="265.688"
        x2="56.1387"
        y2="281.594"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#3A1C9D" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2963_675"
        x1="35.4568"
        y1="238.638"
        x2="35.4568"
        y2="266.782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2963_675"
        x1="16.0421"
        y1="312.753"
        x2="16.0421"
        y2="335.779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_2963_675"
        x1="10.5569"
        y1="352.772"
        x2="32.5606"
        y2="368.477"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#FF5E76" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_2963_675"
        x1="35.5902"
        y1="406.645"
        x2="35.5902"
        y2="428.826"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_2963_675"
        x1="24.2102"
        y1="403.268"
        x2="24.2102"
        y2="426.034"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_2963_675"
        x1="50.8869"
        y1="372.547"
        x2="50.8869"
        y2="388.184"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_2963_675"
        x1="45.0935"
        y1="401.446"
        x2="45.0935"
        y2="423.102"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_2963_675"
        x1="52.3594"
        y1="393.277"
        x2="52.3594"
        y2="414.986"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.0001" stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_2963_675"
        x1="19"
        y1="367"
        x2="42"
        y2="383.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#FF5E76" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_2963_675"
        x1="117.963"
        y1="400"
        x2="115.118"
        y2="287.746"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF5E76" />
        <stop offset="1" stop-color="#ED8898" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_2963_675"
        x1="117.144"
        y1="305"
        x2="114.755"
        y2="401.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AEAEAE" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <radialGradient
        id="paint24_radial_2963_675"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(115.768 279.153) rotate(92.7312) scale(105.249 143.756)"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#FF5E76" />
      </radialGradient>
      <radialGradient
        id="paint25_radial_2963_675"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(116.123 322.94) rotate(98.9137) scale(29.022 127.489)"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#FF5E76" />
      </radialGradient>
      <linearGradient
        id="paint26_linear_2963_675"
        x1="118.028"
        y1="202.577"
        x2="118.028"
        y2="269.099"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <radialGradient
        id="paint27_radial_2963_675"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(109.474 110.621) rotate(92.0407) scale(152.672 155.917)"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#FF5E76" />
      </radialGradient>
      <linearGradient
        id="paint28_linear_2963_675"
        x1="113.141"
        y1="188.379"
        x2="113.141"
        y2="232.071"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_2963_675"
        x1="45.4525"
        y1="420.858"
        x2="121.87"
        y2="441.744"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#3A1C9D" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_2963_675"
        x1="46.4921"
        y1="488.165"
        x2="120.474"
        y2="498.427"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#3A1C9D" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_2963_675"
        x1="65.4275"
        y1="456.87"
        x2="41.1215"
        y2="456.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_2963_675"
        x1="76.6136"
        y1="399.208"
        x2="76.6136"
        y2="425.433"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_2963_675"
        x1="192.521"
        y1="420.858"
        x2="116.104"
        y2="441.744"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#3A1C9D" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_2963_675"
        x1="-7.63918"
        y1="38.7312"
        x2="65.7635"
        y2="52.5418"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ED8898" />
        <stop offset="1" stop-color="#3A1C9D" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_2963_675"
        x1="172.546"
        y1="456.87"
        x2="196.852"
        y2="456.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_2963_675"
        x1="161.36"
        y1="399.208"
        x2="161.36"
        y2="425.433"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_2963_675"
        x1="74.7596"
        y1="487.597"
        x2="82.3848"
        y2="597.748"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF5E76" />
        <stop offset="0.583333" stop-color="#ED8898" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_2963_675"
        x1="16.1052"
        y1="569.442"
        x2="158.571"
        y2="569.442"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#34343C" />
        <stop offset="0.114583" stop-color="#B3B3B3" />
        <stop offset="0.114683" stop-color="#3A3A3A" />
        <stop offset="0.229167" stop-color="#B9B9B9" />
        <stop offset="0.229267" stop-color="#4A4A4B" />
        <stop offset="0.354167" stop-color="#E2E2E2" />
        <stop offset="0.354267" stop-color="#333333" />
        <stop offset="0.53115" stop-color="#CCCCD0" />
        <stop offset="0.53125" stop-color="#333333" />
        <stop offset="0.6874" stop-color="#CACACA" />
        <stop offset="0.6875" stop-color="#333333" />
        <stop offset="0.848858" stop-color="#E3E3E3" />
        <stop offset="0.848958" stop-color="#333333" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_2963_675"
        x1="65.8371"
        y1="510.874"
        x2="60.2771"
        y2="615.611"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.046875" stop-color="#FF5E76" />
        <stop offset="0.583333" stop-color="#ED8898" />
      </linearGradient>
      <linearGradient
        id="paint40_linear_2963_675"
        x1="163.213"
        y1="487.597"
        x2="155.588"
        y2="597.748"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF5E76" />
        <stop offset="0.583333" stop-color="#ED8898" />
      </linearGradient>
      <linearGradient
        id="paint41_linear_2963_675"
        x1="221.868"
        y1="569.442"
        x2="79.4022"
        y2="569.442"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#34343C" />
        <stop offset="0.114583" stop-color="#B3B3B3" />
        <stop offset="0.114683" stop-color="#3A3A3A" />
        <stop offset="0.229167" stop-color="#B9B9B9" />
        <stop offset="0.229267" stop-color="#4A4A4B" />
        <stop offset="0.354167" stop-color="#E2E2E2" />
        <stop offset="0.354267" stop-color="#333333" />
        <stop offset="0.53115" stop-color="#CCCCD0" />
        <stop offset="0.53125" stop-color="#333333" />
        <stop offset="0.6874" stop-color="#CACACA" />
        <stop offset="0.6875" stop-color="#333333" />
        <stop offset="0.848858" stop-color="#E3E3E3" />
        <stop offset="0.848958" stop-color="#333333" />
      </linearGradient>
      <linearGradient
        id="paint42_linear_2963_675"
        x1="172.137"
        y1="510.874"
        x2="177.697"
        y2="615.611"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.046875" stop-color="#FF5E76" />
        <stop offset="0.583333" stop-color="#ED8898" />
      </linearGradient>
      <linearGradient
        id="paint43_linear_2963_675"
        x1="53.326"
        y1="42.861"
        x2="29.102"
        y2="2.59631"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF5E76" />
        <stop offset="1" stop-color="#ED8898" />
      </linearGradient>
      <linearGradient
        id="paint44_linear_2963_675"
        x1="174.216"
        y1="45.861"
        x2="198.439"
        y2="5.5963"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF5E76" />
        <stop offset="1" stop-color="#ED8898" />
      </linearGradient>
      <linearGradient
        id="paint45_linear_2963_675"
        x1="98.2109"
        y1="83.8795"
        x2="161.368"
        y2="159.265"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F4D53" />
        <stop offset="0.148323" stop-color="#C1CAD0" />
        <stop offset="0.316318" stop-color="#2F4D53" />
        <stop offset="0.671875" stop-color="#2F4D53" />
        <stop offset="0.833333" stop-color="#C1CAD0" />
        <stop offset="1" stop-color="#2F4D53" />
      </linearGradient>
      <linearGradient
        id="paint46_linear_2963_675"
        x1="114.13"
        y1="39.7966"
        x2="114.13"
        y2="86.4898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#AEAEAE" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Secondary5",
  props: {
    mask: String,
    face: String,
    body: String,
    hands: String,
    feet: String,
  },
});
</script>
